/* eslint-disable */
// ---------------------------------------------------------------------------
// This file is auto-generated by scripts/generate-users-schema-types.js
// Do not edit this file manually. Instead, update the backend schema or rerun
// the generation script.
// ---------------------------------------------------------------------------

export const allowedPageValues = [
  'home',
  'agents',
  'knowledge_base',
  'tools',
  'items',
  'dev',
  'opensolar',
  'quickbooks',
  'users',
] as const;

export const userStandardFieldKeys = [
  'first_name',
  'last_name',
  'email',
  'username',
  'role',
  'phone',
  'job_title',
  'active',
  'password',
  'allowed_pages',
  'address_line1',
  'address_line2',
  'city',
  'state',
  'postal_code',
  'country',
  'external_id',
] as const;

export const userStandardFieldTypes = [
  'string',
  'boolean',
  'string_list',
  'date',
  'number',
] as const;


export type AllowedPageValue =
  'home' |
  'agents' |
  'knowledge_base' |
  'tools' |
  'items' |
  'dev' |
  'opensolar' |
  'quickbooks' |
  'users';

export interface AllowedPageOption {
  value: AllowedPageValue;
  label: string;
  description?: string;
}

export type UsersStandardFieldKey =
  'first_name' |
  'last_name' |
  'email' |
  'username' |
  'role' |
  'phone' |
  'job_title' |
  'active' |
  'password' |
  'allowed_pages' |
  'address_line1' |
  'address_line2' |
  'city' |
  'state' |
  'postal_code' |
  'country' |
  'external_id';

export type UsersFieldType =
  'string' |
  'boolean' |
  'string_list' |
  'date' |
  'number';

export interface UsersSchemaFieldDefinition {
  key: string;
  label: string;
  type: UsersFieldType;
  required: boolean;
  default?: unknown;
  description?: string;
  options?: unknown[];
  is_custom?: boolean;
  order?: number;
  id?: string;
}

export type UsersStandardFieldDefinition = UsersSchemaFieldDefinition & {
  key: UsersStandardFieldKey;
};

export interface UsersSchemaDefinition {
  allowed_pages: AllowedPageOption[];
  standard_fields: UsersStandardFieldDefinition[];
  allowed_custom_field_types?: UsersFieldType[];
}


export function isAllowedPageValue(value: string): value is AllowedPageValue {
  return (allowedPageValues as readonly string[]).includes(value);
}

export function isUsersFieldType(value: string): value is UsersFieldType {
  return (userStandardFieldTypes as readonly string[]).includes(value);
}

export function isUsersStandardFieldKey(value: string): value is UsersStandardFieldKey {
  return (userStandardFieldKeys as readonly string[]).includes(value);
}

export const generatedUsersSchema: UsersSchemaDefinition = {
  "allowed_pages": [
    {
      "value": "home",
      "label": "Home dashboard"
    },
    {
      "value": "agents",
      "label": "Agents workspace"
    },
    {
      "value": "knowledge_base",
      "label": "Knowledge Base"
    },
    {
      "value": "tools",
      "label": "Tools"
    },
    {
      "value": "items",
      "label": "Items"
    },
    {
      "value": "dev",
      "label": "Developer diagnostics"
    },
    {
      "value": "opensolar",
      "label": "OpenSolar"
    },
    {
      "value": "quickbooks",
      "label": "QuickBooks"
    },
    {
      "value": "users",
      "label": "User management"
    }
  ],
  "standard_fields": [
    {
      "key": "first_name",
      "label": "First name",
      "type": "string",
      "required": true,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "last_name",
      "label": "Last name",
      "type": "string",
      "required": true,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "email",
      "label": "Email",
      "type": "string",
      "required": true,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "username",
      "label": "Username",
      "type": "string",
      "required": false,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "role",
      "label": "Role",
      "type": "string",
      "required": false,
      "default": "user",
      "description": "Determines whether the user can administer other accounts.",
      "options": [
        "user",
        "admin"
      ],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "phone",
      "label": "Phone",
      "type": "string",
      "required": false,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "job_title",
      "label": "Job title",
      "type": "string",
      "required": false,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "active",
      "label": "Active",
      "type": "boolean",
      "required": false,
      "default": true,
      "description": "Toggle to deactivate this account without deleting it.",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "password",
      "label": "Password",
      "type": "string",
      "required": false,
      "default": "",
      "description": "Leave blank to keep the existing password.",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "allowed_pages",
      "label": "Allowed pages",
      "type": "string_list",
      "required": false,
      "default": [],
      "description": "Pages this user can access.",
      "options": [
        "home",
        "agents",
        "knowledge_base",
        "tools",
        "items",
        "dev",
        "opensolar",
        "quickbooks",
        "users"
      ],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "address_line1",
      "label": "Address line 1",
      "type": "string",
      "required": false,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "address_line2",
      "label": "Address line 2",
      "type": "string",
      "required": false,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "city",
      "label": "City",
      "type": "string",
      "required": false,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "state",
      "label": "State/Province",
      "type": "string",
      "required": false,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "postal_code",
      "label": "Postal code",
      "type": "string",
      "required": false,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "country",
      "label": "Country",
      "type": "string",
      "required": false,
      "default": "USA",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    },
    {
      "key": "external_id",
      "label": "External ID",
      "type": "string",
      "required": false,
      "default": "",
      "description": "",
      "options": [],
      "is_custom": false,
      "order": 0
    }
  ],
  "allowed_custom_field_types": [
    "boolean",
    "date",
    "number",
    "string"
  ]
};
